import { render, staticRenderFns } from "./virtualSimulationClassEdit.vue?vue&type=template&id=52361897&scoped=true"
import script from "./virtualSimulationClassEdit.vue?vue&type=script&lang=js"
export * from "./virtualSimulationClassEdit.vue?vue&type=script&lang=js"
import style0 from "./virtualSimulationClassEdit.vue?vue&type=style&index=0&id=52361897&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52361897",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52361897')) {
      api.createRecord('52361897', component.options)
    } else {
      api.reload('52361897', component.options)
    }
    module.hot.accept("./virtualSimulationClassEdit.vue?vue&type=template&id=52361897&scoped=true", function () {
      api.rerender('52361897', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/virtualSimulationClass/virtualSimulationClassEdit.vue"
export default component.exports